// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__xyULA","logo":"styles_logo__1EEn-","text":"styles_text__uxOkZ","btnStay":"styles_btnStay__1UAuK"};